import React, { useState, useEffect, useRef, Fragment } from "react";
import style from './tag.module.css'
import Icons from '../../module.icons';
import gsap from "gsap";
import classNames from "classnames";


function TagField(props) {
    const [results, setResults]=useState();
    const [tags, setTags] = useState();
    const [tagGroups, setTagGroups] = useState();

    useEffect(() => {

        if (props.eventTags) {
            let objs = [...props.eventTags];
            let objGroups = [];

            props.tree.forEach((obj, i) => {
                let idx = objs.findIndex(a => a.id === obj.id)
                if (idx > -1) {
                    objGroups.push(objs[idx])
                }
                obj['children'].forEach((obj2, h) => {
                    let idx2 = objs.findIndex(a => a.id === obj2.id);
                    if (idx2 > -1) {
                        let idx3 = objGroups.findIndex(b => b.id === obj.id);
                        if (idx3 > -1 && objGroups[idx3]['children']) {
                            // console.log(objGroups[idx3])
                            objGroups[idx3]['children'].push(objs[idx2])
                        } else {
                            let newObj = { ...obj }
                            newObj['children'] = [objs[idx2]]
                            objGroups.push(newObj)
                            // console.log("newObj", newObj)
                        }

                    }
                })
            })

            setTagGroups(objGroups);
            console.log('objGroups', objGroups)

            // console.log('props unSaved', props.unSavedChanges['tags'], props.eventTags)
    
            if (props.unSavedChanges['tags']) {
                props.unSavedChanges['tags'].filter(a => (a.status === "new" || a.status === 'add')&&(a.status !== "delete")).forEach(a => {
                    objs.push(a)
                })

                props.unSavedChanges['tags'].filter(a => a.status === "delete").forEach(a => {
                   let delIndex = objs.findIndex(b => b.id === a.id);
                   if (delIndex !== -1) {
                    objs.splice(delIndex, 1);
                }
                })
                
            }
            
            setTags(objs)
           
        }
    }, [props.eventTags, props.unSavedChanges, props.tree])

    useEffect(() => {
        // tags && console.log('tags', tags, props.unSavedChanges['tags'])
        // props.tree && console.log('props.tree', props.tree)
    }, [tags, props.tree])

    function handleOnKeyUp(e){
        // console.log('handleOnKeyUp', e.target.value)
       
        if (e.target.value.length > 2) {
            let objs = props.tags.filter(a => a.text.toLowerCase().includes(e.target.value.toLowerCase()));
            setResults(objs)
        }
        if (e.target.value.length === 0) {
            setResults()
        }

     

    }

    function handleTag(tagValue){
        let tags = [...props.eventTags];
        let tag = tagValue.toLowerCase();
        if (props.unSavedChanges['tags']) {
            props.unSavedChanges['tags'].filter(a => (a.id === "new" || a.status === 'delete')).forEach(b => {
                tags.push(b) 
            })
        
        }
        let exists = props.tags.find(a => a.text.toLowerCase() === tag);
        
        if (exists) {
            exists['status'] = 'add';
            tags.push(exists)
        } else {
            tags.push({
                'id': 'new',
                'text': tag,
                'parent': null,
                'org': props.org,
                'status': 'new'
            })
        }
        console.log('tag updates', tagValue, tags, props.unSavedChanges['tags'])
        props.handleOnChoice(tags, 'tags');
    }

    function handleOnKeyDown(e){
        if (e.keyCode === 13) {
            let tag = e.target.value.toLowerCase();
            handleTag(tag);
            e.target.value = ""
        }
    }

    function onRemoveTag(objId){
        console.log('onRemoveTag', objId);
        let tags = [...props.eventTags];
        let tagUpdates = [];
        if (props.unSavedChanges['tags']) {
            props.unSavedChanges['tags'].filter(a => a.id === "new").forEach(b => {
                tags.push(b) 
                tagUpdates.push(b)
            })
        }
        const index = tags.findIndex(item => item.id === objId);
        if (index !== -1) {
            tags.splice(index, 1);
        }
        console.log('tag splice', tags, index)
        tagUpdates.push({
            'id': objId,
            'status': 'delete'
        })
        props.handleOnChoice(tagUpdates, 'tags');
        console.log('tag updates', tagUpdates);
    }   

    function stripTags(html) {
        let doc = new DOMParser().parseFromString(html, 'text/html');
        return doc.body.textContent || "";
    }
    
    return (
        <div className="flex flexColumn">
            <span className="flex alignCenter">
            
         

                {tagGroups && tagGroups.map((obj0, i) => (
                    ("children" in obj0) ? 
                    <span className={classNames(
                        style.category,
                        "flex",
                        "gap5",
                        "alignCenter"
                    )} key={'tag_' + i}>
                    <span className={style.parent}>{stripTags(obj0.text)}</span>
                    {obj0['children'].map((obj, h) => (<span key={'tag_' + h} className={`${style.tag} flex alignCenter gap10`}>{obj.text} <Icons.Close className="iconSm ui" onClick={() => onRemoveTag(obj.id)} /></span>))}</span>
                        : 
                    <span key={'tag_' + i} className={`${style.tag} flex alignCenter gap10`}>{obj0.text} <Icons.Close className="iconSm ui" onClick={() => onRemoveTag(obj0.id)} /></span>
                ))}

                {props.unSavedChanges && props.unSavedChanges['tags'] && props.unSavedChanges['tags'].filter(a => a.status === 'new').map((obj0, i) => <span key={'tag_' + i} className={`${style.tag} ${style.tagNew} flex alignCenter gap10`}>{obj0.text} <Icons.Close className="iconSm ui" onClick={() => onRemoveTag(obj0.id)} /></span>)}

            </span>
            <span className="flex flexColumn">
          
       
            <div className="settingsRow flex flexColumn">
              
                <input type="search" placeholder="Add a tag" autoComplete="off" id="title" onKeyUp={(e) => handleOnKeyUp(e)} onChange={(e) => handleOnKeyUp(e)} onKeyDown={(e) => handleOnKeyDown(e)}  />
                <span className="flex">
              
                {results && results.map((obj, i) => (
                    <span key={'tag_' + i} className={`${style.tag} flex alignCenter gap10 ui`} onClick={(e)=> handleTag(obj.text)}>{obj.text}</span>
                ))}
         
                </span>
            </div>
            
     
 
            </span>
        </div>
    )
}

export default TagField;
// {props.eventTags.map((obj, i) => (
//     <span key={'tag_' + i} className={`${style.tag} flex alignCenter gap10`}>{obj.text} <Icons.Close className="iconSm ui" onClick={() => onRemoveTag(obj.id)} /></span>
// ))}
// {props.unSavedChanges['tags'] && props.unSavedChanges['tags'].filter(a => a.id === "new").map((obj, i) => (
//     <span key={'tag_' + i} className={`${style.tag} flex alignCenter gap10`}>{obj.text} <Icons.Close className="iconSm ui" onClick={() => onRemoveTag(obj.id)} /></span>
// ))}